namespace $.$$ {

	function process_widget( process: $shm_hitalama_process< any > ) {
		if( process.method_name !== 'run_auto' ) return null

		const host = process.host as {
			widget?: () => {
				title(): string
				link(): $giper_baza_link
				link_str(): string
				map(): $shm_hitalama_map
			}
		} | undefined

		const widget = host?.widget?.()
		if( !widget ) return null

		return widget as $shm_hitalama_map_widget
	}

	function host_title( host: object | undefined ) {
		if( !host ) return ''

		const full = `${ host }.`
		const widgets = [ ... full.matchAll( /(?:^|\.)(Widget<[^>]+>)(?=\.|$)/g ) ]
		const widget = widgets[ widgets.length - 1 ]
		if( widget ) return `${ widget[1] }.`

		return ''
	}

	function short_value( value: unknown ) {
		if( typeof value === 'string' ) return JSON.stringify( value.length > 24 ? value.slice( 0, 21 ) + '...' : value )
		if( typeof value === 'number' || typeof value === 'boolean' || value === null ) return String( value )
		if( value === undefined ) return 'undefined'

		const title = ( value as { constructor?: { name?: string } } )?.constructor?.name
		return title && title !== 'Object' ? title : '{...}'
	}

	export class $shm_hitalama_process_monitor_maps extends $.$shm_hitalama_process_monitor_maps {

		@ $mol_mem
		override pages() {
			const spread = this.spread_current()
			const pages = spread
				? spread instanceof $mol_book2
					? spread.pages_deep()
					: [ spread ]
				: []

			return [
				... pages,
				this.Menu(),
			]
		}

		override widget_click( id: string, event?: Event ) {
			event?.preventDefault()
			const widget = this.process_widget( id )
			if( widget ) this.open_widget( widget )
			else this.detail_click( id, event )
			return event
		}

		process_widget( id: string ) {
			const process = this.$.$shm_hitalama_process.last_by_key( id )
			return process ? process_widget( process ) : null
		}

		@ $mol_action
		open_widget( widget: $shm_hitalama_map_widget ) {
			const map = widget.map()
			const map_id = map.link().str
			const widget_link = widget.link()

			this.$.$mol_state_arg.value( 'map', map_id )

			new this.$.$mol_after_tick( ()=> {
				const map_page = this.$.$shm_hitalama_app.Root(0).Maps().Book( map_id ).Map_page()
				map_page.selected_links( [ widget_link ] )
				map_page.go_to_widget( widget_link )
			} )
		}

		process_title( process: $shm_hitalama_process< any > ) {
			if( process.data().label ) return process.data().label!
			const widget = process_widget( process )
			const title = widget?.title()
			if( title ) return title

			const args = process.args.map( arg => short_value( arg ) ).join( ', ' )
			return `${ host_title( process.host ) }${ process.method_name }(${ args })`
		}

	}

}
